(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/wins-helper.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/wins-helper.js');
"use strict";


const _svs$numbergames$prod = svs.numbergames.productMapping,
  getProductId = _svs$numbergames$prod.getProductId,
  isKeno = _svs$numbergames$prod.isKeno,
  isJoker = _svs$numbergames$prod.isJoker;
svs.numbergames.rules.utils.winsHelper = {
  isWinningRow(_ref) {
    let correctNumbers = _ref.correctNumbers,
      correctExtraNumbers = _ref.correctExtraNumbers,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? '' : _ref$product,
      _ref$kungKeno = _ref.kungKeno,
      kungKeno = _ref$kungKeno === void 0 ? false : _ref$kungKeno,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 0 : _ref$level;
    let productId = getProductId(product);
    if (isJoker(productId)) {
      productId = 'joker';
    }
    const gameRules = svs.numbergames.rules[productId];
    if (!gameRules) {
      svs.numbergames.rules.logger.warn("No rules found using productName: \"".concat(product, "\""));
      return false;
    }
    if (isKeno(product)) {
      return gameRules.winConditions.some(winCondition => level === winCondition.level && correctNumbers >= winCondition.numbers && kungKeno === winCondition.kungKeno);
    }
    return gameRules.winConditions.some(winCondition => correctNumbers >= winCondition.numbers && (!winCondition.numbersExtra || correctExtraNumbers >= winCondition.numbersExtra));
  }
};

 })(window);